import React from 'react';

const HeroSection = () => {
  return (
    <section
      className="relative min-h-[80vh] md:min-h-[90vh] lg:min-h-[100vh] flex items-center justify-center bg-cover bg-center"
      style={{ backgroundImage: "url('/hero_img/image-01.jpg')" }}
    >
      <div className="absolute inset-0 bg-gray-900/70"></div>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative z-10 text-left">
          <h1 className="text-white text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-4 leading-tight">
            Precision <span className="text-[#ECEE07]">Structural Steel</span> Fabrication & Beyond.
          </h1>
          <p className="text-gray-200 text-lg sm:text-xl md:text-xl mb-8">
            Leading the industry in delivering robust and certified metal solutions for complex industrial and commercial projects.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a href="/contact" className="bg-[#ECEE07] border-2 border-white text-gray-900 font-bold py-3 px-8 rounded-lg hover:bg-[#e5e6e5] hover:text-gray-900 transition duration-300 ease-in-out transform hover:scale-105">
              Contact Us
            </a>
            <a href="/our-expertise" className="bg-[#364A9A] border-2 border-white text-white font-bold py-3 px-8 rounded-lg hover:bg-[#e5e6e5] hover:text-gray-900 transition duration-300 ease-in-out transform hover:scale-105">
              Our Expertise
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
